/* VD Cart Sync — keeps the cart DRAWER and the card icons in sync after the
 * Temu-style icon adds (assets/vd-card-cart.js). Two jobs:
 *  1) Re-render the theme cart drawer after an AJAX add. The icon bypasses the
 *     theme's own renderContents (to dodge its null-innerHTML crash on
 *     collection pages), so the drawer DOM was never refreshed — it showed
 *     "empty" even when the cart had items. We re-fetch the drawer section and
 *     swap it in.
 *  2) Badge every product-card icon whose product is already in the cart, so
 *     shoppers can see what they've added (Temu-style quantity badge).
 * Standalone: listens for the global 'ProductAddtoCart' event that
 * vd-card-cart.js dispatches on document after each successful add. */
(function () {
  'use strict';
  if (window.__vdCartSyncInit) return;
  window.__vdCartSyncInit = true;

  function cardHandle(card) {
    var co = card.querySelector('[data-product-handle]');
    if (co && co.getAttribute('data-product-handle')) return co.getAttribute('data-product-handle');
    var a = card.querySelector('.card__media a[href], .card__heading a[href], a.full-unstyled-link[href]');
    var u = a ? a.getAttribute('href') : null;
    if (u) {
      var parts = String(u).split('?')[0].split('/');
      var last = parts[parts.length - 1] || parts[parts.length - 2];
      return last || null;
    }
    return null;
  }

  function sectionId(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    if (sec && sec.id && sec.id.indexOf('shopify-section-') === 0) {
      return sec.id.slice('shopify-section-'.length);
    }
    return null;
  }

  /* Re-render the theme's cart drawer so it shows the real line items. */
  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var secId = sectionId(drawer) || 'cart-drawer';
    fetch('/?section_id=' + encodeURIComponent(secId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            if (fresh.className) {
              /* The fetched drawer is always closed, so keep whatever open-state
                 classes cart-drawer.js's open() put on the live element. */
              var keep = ['animate', 'active'].filter(function (c) {
                return drawer.classList.contains(c);
              });
              drawer.className = fresh.className;
              keep.forEach(function (c) { drawer.classList.add(c); });
            }
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  function ensureStyle() {
    if (document.getElementById('vd-incart-style')) return;
    var st = document.createElement('style');
    st.id = 'vd-incart-style';
    st.textContent =
      '.vd-cart-btn.vd-incart{background:#1f8a4c;color:#fff;border-color:#1f8a4c;}' +
      '.vd-cart-btn .vd-cart-count{position:absolute;top:-6px;right:-6px;min-width:18px;height:18px;' +
      'padding:0 4px;box-sizing:border-box;border-radius:9px;background:#1a1a1a;color:#fff;' +
      'font-size:11px;font-weight:700;line-height:18px;text-align:center;' +
      'box-shadow:0 1px 4px rgba(0,0,0,.35);pointer-events:none;}';
    document.head.appendChild(st);
  }

  function applyInCart(btn, qty) {
    var badge = btn.querySelector('.vd-cart-count');
    if (qty > 0) {
      ensureStyle();
      btn.classList.add('vd-incart');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'vd-cart-count';
        btn.appendChild(badge);
      }
      if (badge.textContent !== String(qty)) badge.textContent = qty;
      var multi = btn.getAttribute('data-vd-mode') !== 'single';
      btn.title = 'In cart (' + qty + ') - tap to add' + (multi ? '' : ' another');
      btn.setAttribute('aria-label', 'In cart, quantity ' + qty + '. Tap to add more.');
    } else {
      if (btn.classList.contains('vd-incart')) btn.classList.remove('vd-incart');
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    }
  }

  function syncCartState() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var byHandle = {};
        var items = (c && c.items) ? c.items : [];
        for (var i = 0; i < items.length; i++) {
          var h = items[i].handle;
          if (!h) continue;
          byHandle[h] = (byHandle[h] || 0) + (items[i].quantity || 0);
        }
        var btns = document.querySelectorAll('.vd-cart-btn');
        for (var j = 0; j < btns.length; j++) {
          var btn = btns[j];
          if (btn.classList.contains('vd-soldout')) continue;
          var card = btn.closest('.card-wrapper') || btn.closest('.card');
          if (!card) continue;
          var hh = cardHandle(card);
          applyInCart(btn, (hh && byHandle[hh]) ? byHandle[hh] : 0);
        }
      })
      .catch(function () {});
  }

  /* After each icon add, vd-card-cart.js dispatches this on document. */
  document.addEventListener('ProductAddtoCart', function () {
    refreshCartDrawer();
    setTimeout(syncCartState, 80);
  });

  function start() { syncCartState(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { setTimeout(syncCartState, 700); });

  /* Re-badge cards injected later (infinite scroll / AJAX). Debounced; the
     badge writes converge so the observer settles after a pass or two. */
  try {
    var t, target = document.getElementById('MainContent') || document.body;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(syncCartState, 450);
    });
    mo.observe(target, { childList: true, subtree: true });
  } catch (e) {}
})();
